export default __webpack_public_path__ + "static/home3-e9741a77acc31e0b1c396276d7ea70a6.jpg";